import '../css/Filter.css';
import { useNavigate } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import ApiConfig from '../utils/ApiConfig';
import axios from 'axios';
import ApiResponse from '../model/response/ApiResponse';
import { ToastContainer, toast } from "react-toastify";
import { useEffect, useState } from 'react';
import ProfileDetailsRespone from '../model/response/ProfileDetailsRespone';
import default_avatar from '../images/default_avatar.png';
import { Oval } from "react-loader-spinner";
import user from '../images/user.png';
import logo from '../images/logo.jpeg';
import Notification from './Notification';
import Popup from './Popup';
import NumberEditpopup from './NumberEditpopup';
import EmailEditpopup from './EmailEditpopup';
import HomeList from './HomeList';



function Editprofile() {
  const rawVal = localStorage.getItem('loginVal');
  let loginVal = rawVal ? JSON.parse(rawVal) : null;
  let token = loginVal ? loginVal.token : null;



  const gender = localStorage.getItem("gender");

  const savedImage = localStorage.getItem("image")
  console.log("Viewpage Image:", savedImage);


  var location = useLocation();
  var { ImageUpload, userId, user_Id } = location.state || {};
  const navigation = useNavigate()
  const [profile, SetProfile] = useState({});
  const [isLoading, setIsLoading] = useState(false)
  const [showMenu, setShowMenu] = useState(false);
  const [showNotif, setShowNotif] = useState(false);
  const [showNumberUpdate, setShowNumberUpdate] = useState(false);
  const [showEmailUpdate, setShowEmailUpdate] = useState(false);
  const [placeofbirth, setPlaceofBirth] = useState(false);
  const [chartData, setChartData] = useState(null);


  const rasiList = [
    { id: 11, name: "Meena" },
    { id: 0, name: "Mesha" },
    { id: 1, name: "Vrishabha" },
    { id: 2, name: "Mithuna" },
    { id: 10, name: "Kumbha" },
    { id: "center", name: "CENTER" },
    { id: 3, name: "Karkataka" },
    { id: 9, name: "Makara" },
    { id: 4, name: "Simha" },
    { id: 5, name: "Kanya" },
    { id: 6, name: "Tula" },
    { id: 7, name: "Vrischika" },
    { id: 8, name: "Dhanu" }
  ];


  function clicktoImageUpload() {
    navigation('/ImageUpload', { state: { ImageUpload } })
  }
  function clicktoDocumentUpload() {
    navigation('/Documentupload', { state: { ImageUpload } })
  }
  function clicktoBasic_details() {
    navigation('/Basic_details', { state: { profile } })
  }
  function clicktoReligion_details() {
    navigation('/Religion_details', { state: { profile } })
  }
  function clicktoGroom_location() {
    navigation('/Groom_location', { state: { profile } })
  }

  function clicktoFamily_details() {
    navigation('/Family_details', { state: { profile } })
  }
  function clicktoProfessional_details() {
    navigation('/Professional_details', { state: { profile } })
  }
  function clicktoNumberEditpopup() {
    // navigation('/NumberEditpopup', { state: { profile } })
  }
  function clicktoEmailEditpopup() {
    // navigation('/EmailEditpopup', { state: { profile } })
  }
  function clicktoViewpage() {
    navigation('/Viewpage')
  }

  function clickInterestPage() {
    navigation('/Interestpage')
  }

  function showToast(message) {
    toast.success(message, {
      position: "top-right",
      autoClose: 2000
    });
  }

  useEffect(() => {


    getProfileAPICall();

  }, []);
  function showToastFailed(message) {
    toast.error(message, {
      position: "top-right",
      autoClose: 2000
    });
  }
  function getProfileAPICall() {
    var obj = { user_Id: loginVal.user_Id, login_user_id: loginVal.user_Id }//user_Id: userId

    console.log("Response:", JSON.stringify(obj));
    axios.post(
      ApiConfig.getUrl("User/getUsersProfile"),
      JSON.stringify(obj),
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    )
      .then(async response => {
        console.log("Response:", response.data);
        const api = ApiResponse.fromJson(response.data);
        console.log("Response:", api.statusCode);
        // console.log("statusCode:", login.user_Id);
        if (api.statusCode == 200) {
          const profileVal = ProfileDetailsRespone.fromJson(api.response);

          if (profileVal.mobile_Number) {
            try {
              profileVal.mobile_Number = await ApiConfig.decrypt(profileVal.mobile_Number);
            } catch (e) { console.error("Mobile decryption failed:", e); }
          }
          if (profileVal.email) {
            try {
              profileVal.email = await ApiConfig.decrypt(profileVal.email);
            } catch (e) { console.error("Email decryption failed:", e); }
          }

          SetProfile(profileVal);



          // localStorage.setItem("image", profileVal.profileImage)
          // const savedImage = localStorage.getItem("image");
          // console.log("savedImage:", savedImage);

          console.log(
            "PROFILE RESPONSE:",
            JSON.stringify(profileVal)
          );
          generateBirthChart();
          // showToast(api.message);
        } else {
          showToastFailed(api.errorMessage);
        }

      })
       .catch(error => {

            if (error.response?.status === 401) {
               localStorage.removeItem("token");
               localStorage.removeItem("loginVal");

               navigation("/login");
               return;
            }

            showToastFailed(error);
            console.error("Error:", error);
         });
   }



  function generateBirthChart() {
  console.log(
    "🔥 generateBirthChart CALLED",
    new Date().toISOString()
  );

  axios
    .post(
      `${ApiConfig.getUrl(
        "api/Astrology/generateBirthChart"
      )}/${Number(loginVal.user_Id)}`,
      null,
      {
        params: {
          opponentId: loginVal.user_Id
        },
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    )
    .then((response) => {
      console.log(
        "🔥 Birth Chart API Response:",
        response.data
      );

      const api = ApiResponse.fromJson(response.data);

      if (api.statusCode === 200 && api.status === true) {
        console.log(
          "✅ API RESPONSE:",
          api.response
        );

        // ============================================
        // JSON STRING -> OBJECT
        // ============================================

        const parseJson = (value, fieldName) => {
          if (!value) {
            return null;
          }

          try {
            const parsed =
              typeof value === "string"
                ? JSON.parse(value)
                : value;

            console.log(
              `✅ ${fieldName}:`,
              parsed
            );

            return parsed;
          } catch (error) {
            console.error(
              `❌ ${fieldName} JSON Parse Error:`,
              error
            );

            return null;
          }
        };

        // ============================================
        // PARSE DETAILS
        // ============================================

        const planetPosition = parseJson(
          api.response?.planet_Position,
          "Planet Position"
        );

        const manglikDetails = parseJson(
          api.response?.manglik_Details,
          "Manglik Details"
        );

        const kalsarpaDetails = parseJson(
          api.response?.kalsarpa_Details,
          "Kalsarpa Details"
        );

        // ============================================
        // FINAL CHART DATA
        // ============================================

        const finalChartData = {
          ...api.response,

          planet_Position: planetPosition,

          manglik_Details: manglikDetails,

          kalsarpa_Details: kalsarpaDetails
        };

        // ============================================
        // SET STATE
        // ============================================

        setChartData(finalChartData);

      } else {
        showToastFailed(
          api.message ||
          "Birth chart generation failed."
        );
      }
    })
    .catch((error) => {
      console.error(
        "❌ Birth Chart Error:",
        error
      );
        const backendMessage =
          error?.response?.data?.message ||
          error?.response?.data?.errorMessage ||
          "Birth chart generation failed.";

        showToastFailed(backendMessage);
      });
  }
  const getPlanetsForRasi = (rasiId) => {
    if (!chartData) return [];

    const planetList = chartData?.planet_Position?.data?.planet_position || [];

    if (!Array.isArray(planetList)) return [];

    return planetList.filter(
      (planet) => Number(planet?.rasi?.id) === Number(rasiId)
    );
  };

  function clientdata(label, value) {
    return (
      <div className="row g-0 mb-1">
        <div className="col-5 col-md-4" style={{ fontFamily: "Inter-Regular" }}>
          <label className="mb-0"> {label} </label>
        </div>
        <div className="col-7 col-md-8" style={{ fontFamily: "Inter-semibold" }}>
          <label className="mb-0 text-break"> {value}</label>
        </div>
      </div>
    );
  }

  function clickSearchPage() {
    navigation('/Searchpage')
  }
  function clickHomeListPage() {
    navigation('/HomeList')
  }
  function Examplepopup(name) {
    console.log("Examplepopup" + name);

  }
  function clickLogin() {
    logoutAPICall();
  }

  function logoutAPICall() {

    setIsLoading(true);

    axios.post(
      ApiConfig.getUrl("User/logout"),
      {
        user_Id: loginVal.user_Id
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    )
      .then((response) => {

        const api = ApiResponse.fromJson(response.data);

        setIsLoading(false);

        if (api.status && api.statusCode === 200) {

          showToast("Logout successful.");


          setTimeout(() => {
            localStorage.clear();
            navigation("/login", { replace: true });
          }, 1000);

        } else {
          showToastFailed(api.errorMessage || "Logout failed");
          localStorage.clear();
          navigation("/login", { replace: true });

        }

      })
      .catch((error) => {

        setIsLoading(false);

        if (error.response?.status === 401) {
          localStorage.clear();
          navigation("/login", { replace: true });
          return;
        }

        console.error(error);
        showToastFailed("Logout failed");
        localStorage.clear();
        navigation("/login", { replace: true });
      });
  }
  const disableRightClick = (e) => {
    if(ApiConfig.ENV == "PRD"){
    e.preventDefault();
    }
  };

  return (


    <>

      <div className="fullview w-75" onContextMenu={disableRightClick} >
        <ToastContainer />
        {isLoading && (
          <div className="loader-overlay">
            <Oval
              height={60}
              width={60}
              color="#ffffff"
              secondaryColor="#cccccc"
              strokeWidth={4}
              visible={true}
            />
          </div>
        )}

        <div className="top-bar">
          <div className='container '>
            <ul className=" d-flex align-items-center mb-0 position-relative">
              <img src={logo} alt='logo' style={{ width: '70px' }} />
              <li className='m-3 p-1' onClick={clicktoViewpage}>
                <i className="bi bi-people d-inline m-1"></i>
                <span className="d-none d-sm-inline text-decoration-none text-dark">All matches</span>
              </li>
              <li className="m-1 p-1" onClick={clickHomeListPage}>
                <i className="bi bi-house d-inline m-2"></i>
                <span className="d-none d-sm-inline text-decoration-none text-dark">Home</span>
              </li>
              <li className='m-1 p-1' onClick={clickInterestPage}><i className="bi bi-heart d-inline m-2"></i>
                <span className="d-none d-sm-inline text-decoration-none text-dark">Interests</span>

              </li>
              <li onClick={clickSearchPage} className='m-2 p-1'><i className="bi bi-search d-inline m-2"></i>
                <span className="d-none d-sm-inline text-decoration-none text-dark">Search</span></li>
              <li className='m-2 p-1' onClick={() => setShowNotif(true)}>

                <i className="bi bi-bell d-inline m-2"></i>
                <span className="d-none d-sm-inline  text-decoration-none text-dark">Notification</span>
              </li>

              <li className='m-2 p-1' onClick={clickLogin}>

                <i className="bi bi-box-arrow-left d-inline m-2"></i>
                <span className="d-none d-sm-inline  text-decoration-none text-dark" >Logout</span>
              </li>
              <Notification
                show={showNotif}
                onClose={() => setShowNotif(false)}
              />

            </ul>
          </div>
        </div>






        <div className='container '>

          <div className=' card border shadow-none ' style={{ marginTop: "100px", display: "flex", flexWrap: "nowrap", borderRadius: "0"}} >
            <div className='row'>

              <div className="col-lg-3 col-sm-12 p-2">
                <div style={{ position: "relative" }}>

                  {(profile.isPaid === true || profile.is_Paid === true) && (
                    <div
                      style={{
                        position: "absolute",
                        top: "5px",
                        right: "5px",
                        zIndex: 10,
                        background: "#FFD700",
                        color: "#000",
                        padding: "4px 8px",
                        borderRadius: "15px",
                        fontSize: "11px",
                        fontWeight: "bold",
                        boxShadow: "0 2px 5px rgba(0,0,0,0.3)"
                      }}
                    >
                      ⭐ {profile.lookUpId || "Premium"}
                    </div>
                  )}
                  <img
                    className="w-100  ms-2"
                    src={
                      profile.profileImages?.find(img => img.isProfileImage)?.profilePath ||
                      default_avatar
                    }
                    style={{ objectFit: "cover", height: "15%" }}
                  />
                </div>
                {/* <div className='d-flex flex-column flex-sm-row my-3  flex-nowrap'>
                      <button className='btn bg-info text-center w-60 fw-bold'
                        style={{ fontSize: "15px", paddingBottom: "40px" }}
                        onClick={clicktoImageUpload}>Add/Edit Photos</button><br />


                      <button className='btn bg-primary text-center w-60 fw-bold'
                        style={{ fontSize: "15px", paddingBottom: "40px" }}
                        onClick={clicktoDocumentUpload}>Verify Document</button>
                    </div> */}

              </div>





              <div className="col-lg-6 col-sm-12 ms-0 ms-md-5 mt-2">
                <div><label className="name"><b>{profile.first_Name ?? ""}</b></label></div>


                <div style={{ paddingBottom: '10px' }} ><label className='normal-text-grey'> IMIT{profile.userNum}</label></div>

                <ul style={{
                  display: "flex",
                  flexWrap: "wrap",
                  listStyleType: "disc",
                  paddingLeft: "0px",
                  margin: "0", textDecoration: "none",
                  listStyleType: "none"
                }}>

                  <li style={{
                    paddingTop: 0, paddingBottom: 0, paddingRight: 10, paddingLeft: 0,
                    listStyleType: 'none',
                    textDecoration: 'none',
                    display: 'flex',
                    alignItems: 'center',
                  }} className='normal-text'>
                    <span style={{
                      paddingRight: 10,
                      fontSize: '1.2rem',
                      marginBottom: '4px',
                      textDecoration: 'none', // keep
                    }}>•</span>{profile.age} yrs
                  </li>

                  <li style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 10 }} className='normal-text'>
                    <span style={{
                      fontSize: '1.2rem',
                      marginBottom: '4px',
                      textDecoration: 'none', // keep
                    }}>•</span> {profile.height} CM
                  </li>
                  <li style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 10, }} className='normal-text'>
                    <span style={{
                      fontSize: '1.2rem',
                      marginBottom: '4px',
                      textDecoration: 'none', // keep
                    }}>•</span> {profile.caste}
                  </li>


                </ul>

                <ul style={{
                  display: "flex",
                  flexWrap: "wrap",
                  listStyleType: "disc",
                  paddingLeft: "0px",
                  margin: "0",
                }}>


                  <li style={{ paddingTop: 0, paddingBottom: 0, paddingRight: 10, paddingLeft: 0 }} className='normal-text'>
                    <span style={{
                      fontSize: '1.2rem',
                      marginBottom: '4px',
                      textDecoration: 'none', // keep
                    }}>•</span> {profile.religion}
                  </li>
                  <li style={{ paddingTop: 0, paddingBottom: 0, paddingRight: 10, paddingLeft: 0 }} className='normal-text'>
                    <span style={{
                      fontSize: '1.2rem',
                      marginBottom: '4px',
                      textDecoration: 'none', // keep
                    }}>•</span> {profile.education_in_Detail}
                  </li>

                  <li style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 10 }} className='normal-text'>
                    <span style={{
                      fontSize: '1.2rem',
                      marginBottom: '4px',
                      textDecoration: 'none', // keep
                    }}>•</span> {profile.occupation}
                  </li>

                </ul>

                <ul style={{
                  display: "flex",
                  flexWrap: "wrap",
                  listStyleType: "disc",
                  paddingLeft: "0px",
                  listStylePosition: "inside",
                  margin: "0",
                }}>


                  <li style={{ paddingTop: 0, paddingBottom: 0, paddingRight: 10, paddingLeft: 0 }} className='normal-text'>
                    <span style={{
                      fontSize: '1.2rem',
                      marginBottom: '4px',
                      textDecoration: 'none', // keep
                    }}>•</span> {profile.district}
                  </li>

                  <li style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 10 }} className='normal-text'>
                    <span style={{
                      fontSize: '1.2rem',
                      marginBottom: '4px',
                      textDecoration: 'none', // keep
                    }}>•</span> {profile.state}
                  </li>
                  <li style={{ paddingTop: 0, paddingBottom: 0, paddingLeft: 0, paddingRight: 10, }} className='normal-text'>
                    <span style={{
                      fontSize: '1.2rem',
                      marginBottom: '4px',
                      textDecoration: 'none', // keep
                    }}>•</span> {profile.country}.
                  </li>
                </ul>


                {/* <div><label className='normal-text'>IMIT{profile.userid} | {profile.age ?? " "} yrs , {profile.height} cms ,</label></div>
                  <div><label className='normal-text'>{profile.religion}, {profile.caste} </label></div>
                  <div><label className='normal-text'>{profile.education_in_Detail},{profile.occupation}</label></div>
                  <div><label className='normal-text'>{profile.district} &  {profile.state},{profile.citizenship}.</label></div>
                  <div><label className='normal-text'>{profile.country}.</label></div> */}

              </div>
            </div>

          </div>
          <div className='card border shadow-none  mt-3 mb-2 p-3 ' style={{
            backgroundColor: "var(--primary-color)", height: "200px", borderRadius: "0", boxShadow: "0"

          }}>
            <div className='mt-2 text-light'>Photos are the first thing that prospects look at, </div>
            <div className='mt-2 text-light'>Add groom's Photo and get 10 times more responses!</div>
            <div className='d-flex'>
              <button className='btn bg-light w-20 mt-3 btn-outline-info'
                onClick={clicktoImageUpload}
                style={{ fontSize: "12px" }}>Upload Photos Now </button>
              <button className='btn bg-light w-20 mt-3 btn-outline-info'
                style={{ fontSize: "12px" }}
                onClick={clicktoDocumentUpload}>Verify Document</button>
            </div>
          </div>
          <div className='card border shadow-none mt-1' style={{ borderRadius: "0" }}>
            <div className='topic-row'>
              <b className="h4 p-3 fs-5" style={{ fontFamily: "Inter-semibold" }}>Basic Details</b>
              <button className='Edit-btn ms-0.5' onClick={clicktoBasic_details}><i className="bi bi-pencil "></i> Edit</button></div>

            <div>
              {clientdata("Profile Created for", " : " + (profile.created_For ?? ""))}
              {clientdata("Marital Status", " : " + (profile.marital_Status ?? ""))}
              {clientdata("Name", " : " + (profile.first_Name ?? ""))}
              {/* {clientdata("Mobile Number", ":" + (""))} */}
              {clientdata("Age", " : " + profile.age ?? "")}
              {clientdata("Mother Tongue", " :" + profile.mother_Tongue ?? "")}
              {clientdata("Height", " : " + profile.height + " CM" ?? "")}
              {clientdata("Body Type", " : " + (profile.body_Type ?? ""))}
              {clientdata("Weight", " : " + (profile.weight + " Kg" ?? ""))}
              {gender?.toLowerCase() === "male" &&
                clientdata(
                  "living Preference ",
                  ": " + (profile.living_Preference ?? ""),
                  39
                )
              }
            </div>
            <div>
              {clientdata("Physical Status", " : " + (profile.disability ?? "Add Disability"))}
              {clientdata("Drinking Habits", " : " + (profile.drinking_Habit ?? ""))}
              {clientdata("Eating Habits", " : " + profile.eating_Habit ?? "Add Eating Habbit")}
              {clientdata("Smoking Habits", " : " + profile.smoking_Habit ?? "")}
            </div>
          </div>

          <div className='card border shadow-none mt-1' style={{ borderRadius: "0", boxShadow: "0" }}>
            <b className="h4 p-3 fs-5" style={{ fontFamily: "Inter-semibold" }}>Contact Information</b>
            <div className='topic-row d-flex justify-content-between align-items-center p-1  flex-nowrap '>
              <div className="flex-grow-1">
                {clientdata("Mobile Number", " : " + (profile.mobile_Number ?? ""))}
              </div>
              {/* <button className='Edit-btn ' onClick={() =>
                setShowNumberUpdate(true)}>
                <i className="bi bi-pencil ms-0.5"></i>Edit
              </button> */}
            </div>

            <div className='topic-row d-flex justify-content-between align-items-center p-1 flex-nowrap'>
              <div className="flex-grow-1">
                {clientdata("Email Id", " : " + (profile.email ?? ""))}
              </div>
              {/* <button className='Edit-btn' onClick={() => setShowEmailUpdate(true)}>
              <i className="bi bi-pencil ms-0.5"></i> Edit
            </button> */}
            </div>
          </div>

          <Popup show={showNumberUpdate} onClose={() => setShowNumberUpdate(false)} >


            <NumberEditpopup />

          </Popup>
          <Popup show={showEmailUpdate} onClose={() => setShowEmailUpdate(false)} >


            <EmailEditpopup />

          </Popup>

          {/* <EmailEditpopup show={showEmailUpdate} onClose={() => setShowNumberUpdate(false)} /> */}

          <div className='card border shadow-none mt-1' style={{ borderRadius: "0", boxShadow: "0" }}>
            <div className='topic-row'>
              <b className="h4 p-3 fs-5" style={{ fontFamily: "Inter-semibold" }}>Religion Information</b>
              <button className='Edit-btn' onClick={clicktoReligion_details}><i className="bi bi-pencil me-1"></i>Edit</button></div>

            <div>
              {clientdata("Religion", " : " + profile.religion ?? "")}
              {clientdata("Caste", " : " + profile.caste ?? "")}
              {clientdata("SubCaste", " : " + profile.sub_Caste ?? "")}
              {clientdata("Gothram", " : " + profile.gothram ?? "")}

            </div>

            <div>
              {/* {clientdata("Date of Birth", " : " + profile.date_Of_Birth ?? "")} */}
              {clientdata("Date Of Birth", ": " + (profile.date_Of_Birth?.split(" ")[0] ?? "")
              )}
              {clientdata("Time of Birth", " : " + profile.time_of_birth ?? "")}
              {clientdata("Place of Birth", ":" + profile.place_of_Birth ?? "")}
            </div>
          </div>
          <div className='card border shadow-none mt-1' style={{ borderRadius: "0", boxShadow: "0" }}>
            <div className='topic-row '>
              <b className="h4 p-3 fs-5" style={{ fontFamily: "Inter-semibold" }}>Groom's/Bride's Location</b>
              <button className='Edit-btn' onClick={clicktoGroom_location}><i className="bi bi-pencil me-1"></i>Edit</button></div>

            <div>
              {clientdata("Address", " : " + ((profile.line_1 ?? "") + " " + (profile.line_2 ?? "")))}

              {clientdata("Country", " : " + profile.country ?? "")}
              {clientdata("State", " : " + profile.state ?? "")}
              {clientdata("Ancestral Origin (Native)", " : " + profile.ancestral_Origin ?? "")}
              <div>
                {clientdata("City", " : " + profile.district ?? "")}
                {clientdata("Citizenship", ":" + profile.citizenship ?? "")}
              </div>
            </div>
          </div>
          <div className='card border shadow-none mt-1' style={{ borderRadius: "0", boxShadow: "0" }}>
            <div className='topic-row'>
              <b className="h4 p-3 fs-5" style={{ fontFamily: "Inter-semibold" }}>Professional Information</b>
              <button className='Edit-btn' onClick={clicktoProfessional_details}><i className="bi bi-pencil me-1"></i>Edit</button></div>
            <div className="">
              <div>
                {clientdata("Education", " : " + profile.education_in_Detail ?? "")}
                {/* {clientdata("Education in Detail",":"+profile.education_CategoryId??"")} */}
                {clientdata("College / Institution", " : " + profile.institution ?? "")}
                {clientdata("Employed in", " : " + profile.employed_In ?? "")}
                {clientdata("Occupation", " : " + profile.occupation ?? "")}
                {clientdata("Salary", " : " + profile.from_Income ?? "")}
              </div>
            </div>
          </div>
          <div className='card border shadow-none mt-1' style={{ borderRadius: "0", boxShadow: "0" }} >
            <div className='topic-row'>
              <b className="h4 p-3 fs-5" style={{ fontFamily: "Inter-semibold" }}>Family Details</b>
              <button className='Edit-btn' onClick={clicktoFamily_details}><i className="bi bi-pencil me-1"></i>Edit</button></div>
            <div>
              {clientdata("Family Values", " : " + profile.family_Values ?? "")}
              {clientdata("Family Type", " : " + profile.family_Type ?? "")}
              {clientdata("Family Status", " : " + profile.family_Status ?? "")}
              {clientdata("No of Sister(s)", " : " + profile.no_Of_Sister ?? "")}
              {clientdata("No of Sister(s) Married", " : " + profile.siters_Married ?? "")}

            </div>
            <div>
              {clientdata("Father's Occupation", " : " + profile.father_Occupation ?? "")}
              {clientdata("Mother's Occupation", " : " + profile.mother_Occupation ?? "")}
              {clientdata("No of Brother(s)", " : " + profile.no_Of_Brothers ?? "")}
              {clientdata("No of Brother(s) Married", " : " + profile.brothers_Married ?? "")}
              {/* {clientdata("Family Location ", ":" + profile.lives_In ?? "")} */}

            </div>
          </div>


          <div className='card border shadow-none mt-1' style={{ borderRadius: "0", boxShadow: "0" }} >
            <div className='topic-row'>
              <b className="h4 p-3 fs-5" style={{ fontFamily: "Inter-semibold" }}>✨ My BirthChart</b>
              <button className='Edit-btn' onClick={clicktoReligion_details}><i className="bi bi-pencil me-1"></i>Edit</button></div>
            <div>

              {chartData && (
                <div className="birth-result-card mt-4">
                  <div className="birth-info text-center">
                        <b>Raasi: </b> {chartData?.raasi_En} ,
                        <b>Star:</b> {chartData?.star_En} ,
                        <b>Lagna:</b>  {chartData?.lagna_En}
                      </div>
                      <div className="birth-info text-center">
                    <b>Manglik Dosha:</b>{" "}
                    {chartData?.has_Manglik_Dosha ? "Yes" : "No"}

                    <br />

                    <b>Kalsarpa Dosha:</b>{" "}
                    {chartData?.has_Kalsarpa_Dosha ? "Yes" : "No"}

                    <br />

                    <b>Manglik Details:</b>{" "}
                    {chartData?.manglik_Details?.data?.description || "No details available"}

                    <br />

                    <b>Kalsarpa Details:</b>{" "}
                    {chartData?.kalsarpa_Details?.data?.description || "No details available"}
                  </div>


                  {/* RAASI / STAR / LAGNA */}
                  {/* <div className="birth-info text-center">
                    <div>
                      <strong>Raasi :</strong>{" "}
                      {chartData?.raasi_Local || "-"} ({chartData?.raasi_En || "-"})
                    </div>
                    <div>
                      <strong>Star :</strong>{" "}
                       {chartData?.star_Local || "-"} ({chartData?.star_En || "-"})
                    </div>
                    <div>
                      <strong>Laknam :</strong> {" "}
                       {chartData?.lagna_Local || "-"} ({chartData?.lagna_En || "-"})
                    </div>
                  </div> */}

                  {/* RASI CHART */}
                  <div className="text-center mt-5">

                    <div className="south-chart-grid">
                      {rasiList.map((rasi, index) => {

                        if (rasi.id === "center") {
                          return (
                            <div key={index} className="chart-center-box">
                              <div className="center-title">Raasi</div>
                            </div>
                          );
                        }

                        const planets = getPlanetsForRasi(rasi.id);

                        const localRasiName =
                          planets.length > 0
                            ? (
                              planets[0]?.rasi?.name_en,
                              planets[0]?.rasi?.name_local ||
                              planets[0]?.rasi?.name ||
                              rasi.name
                            )
                            : rasi.name;

                        return (
                          <div key={index} className="chart-box">
                            <div className="rasi-name local-language-text">
                              {localRasiName}
                            </div>

                            <div className="planets-content">
                              {planets.map((planet, pIndex) => {
                                const planetLocalName =
                                  planet?.name_en ||
                                  planet?.name_local ||
                                  planet?.name ||
                                  "-";

                                return (
                                  <div key={pIndex} className="planet-badge local-language-text">
                                    {planetLocalName}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>

                  {/* PLANET POSITION TABLE */}
                  {/* <div className="mt-5">
                    <h5 className="mb-3">Planet Positions</h5>
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th>Planet</th>
                            <th>Rasi</th>
                            <th>Degree</th>
                            <th>Retrograde</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(chartData?.planet_Position?.data?.planet_position || []).map((planet, index) => (
                            <tr key={index}>
                              <td>{planet?.name}</td>
                              <td>{planet?.rasi?.name}</td>
                              <td>{Number(planet?.degree || 0).toFixed(2)}</td>
                              <td>{planet?.is_retrograde ? "Yes" : "No"}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div> */}

                </div>
              )}

            </div>
          </div>
        </div>




      </div>
      <footer className='bg-dark text-white text-center'>
        <label style={{ fontSize: "12px" }}>Copyright © 2026 NavGraph Technologies. All Rights Reserved.</label>
      </footer>
    </>
  );
}
export default Editprofile;